<template>
    <div
        class="w-full rounded-md border border-gray-200 bg-white md:w-[calc((100%-24px)/2)] lg:w-[calc((100%-48px)/3)] mt-[42px]"
    >
        <div class="flex items-center justify-between p-[21px]">
            <EcomailLogo />
            <div class="group relative">
                <AtomicButton type="button" size="md" color="yellow">
                    {{ $t("vue.connect") }}
                </AtomicButton>
                <div
                    class="pointer-events-none absolute bottom-full right-0 mb-2 hidden group-hover:block"
                    aria-hidden="true"
                >
                    <Tooltip>{{ $t("vue.coming_soon") }}</Tooltip>
                </div>
            </div>
        </div>
        <div
            class="flex flex-col gap-2 px-[21px] pb-[21px] text-sm text-gray-500"
        >
            <div>{{ $t("vue.ecomail_integration_connect_desc") }}</div>
            <div>{{ $t("vue.ecomail_integration_feature_desc") }}</div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import EcomailLogo from "./EcomailLogo.vue";
</script>
